/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState,useCallback } from "react";
import { useTranslation } from 'react-i18next';
import searchIcon from '../../../assets/icons/search.svg';
import { DataGrid ,NGODatePicker} from "../../../common";
import { APIEndpoint } from "../../../utils/axios";
import { formatDateByTimezone } from "../../../utils/commonFunctions";
import CustomSelect from "../../../common/CustomSelect";
const Columns = [
    {field: 'itemCode', headerName: 'Item Code',resizable:true,pinned:'left', minWidth: 120,cellStyle: {
        whiteSpace: 'nowrap',
        overflow:'hidden',
        textOverflow:'ellipsis',
      },tooltipField:"itemCode"},
    {field: 'itemName', headerName: 'Item Name',resizable:true,tooltipField:'itemName', minWidth: 120,pinned:'left',width:150,cellStyle: {
        whiteSpace: 'nowrap',
        overflow:'hidden',
        textOverflow:'ellipsis',
      },
    },
    {field: 'openingStock', headerName: 'Opening Stock', cellStyle: params => {
       if(params.value<0){
        return {color: '#ef3e39',fontWeight:"700"};
       }else if(params.value>0){
        return {color: 'rgb(10 255 12)'};
       }else{
        return null;
       }
      }, minWidth: 95,resizable: true},
    {field: 'purchase', headerName: 'GRN', cellStyle: params => {
        if(params?.value){
            return {fontWeight:"700"};
        }
        else{
            return null;
        }
       }, minWidth: 75,maxWidth:120,},
    {field: 'reverseGrn',headerName: 'Reverse GRN', minWidth: 110,maxWidth:120,},
    {field: 'transferIn', headerName: 'Transfer In', minWidth: 110,maxWidth:120,},
    {field: 'offload', headerName: 'Offload', minWidth: 110,maxWidth:120},
    {field: 'wastage', headerName: 'Wastage', minWidth: 110,maxWidth:120},
    {field: 'variance', headerName: 'Variance', minWidth: 110,maxWidth:120},
    {field: 'placeOrder', headerName: 'Uplifted', minWidth: 110,maxWidth:120, valueFormatter: params=>{
        if(params.value === undefined && params.data!==undefined){
           return 0
         }
     }},
    {field: 'transferOut',headerName: 'Transfer Out', minWidth: 110,maxWidth:120,},
    {field: 'pliferage', headerName: 'Pliferage', valueFormatter: params=>{
        if(params.value === undefined && params.data!==undefined){
           return 0
         }
     }, minWidth: 110,maxWidth:120},
    {field: 'onboardSales', headerName: 'Onboard Sales', minWidth: 110,resizable: true},
    {field: 'adjustment', headerName: 'Stock Adjustment',cellStyle: params => {
        if(params?.value){
            return {fontWeight:"700"};
        }
        else{
            return null;
        }
       }, minWidth: 110,maxWidth:150},
    {field: 'closingStock',headerName: 'Closing Stock', cellStyle: params => {
        if(params.value<0){
            return {color: '#ef3e39',fontWeight:"700"};
        }else if(params.value>0){
            return {color: 'rgb(10 255 12)'};
        }else{
            return null;
        }
       }, minWidth: 110,maxWidth:120,},
    {field: 'unit',headerName: 'Unit', minWidth: 100,},

];

export const WarehouseInventory = (props) => {
  const { t ,ready} = useTranslation();
    const [warehouses, setWarehouses] = useState([]);
    const [wareHouseArr,setWareHouseArr]=useState([]);
    const [pageLimit, ] = useState(50);
    const [searchKey, setSearchKey] = useState('');
    const [date, setDate] = useState(new Date());
    const [selWarehouse, setSelWarehouse] = useState('');
    const [, setSelFiltersMessage] = useState('');
    const [noResultsMessage, setNoResultsMessage] = useState("Please select Warehouse & Date filters")

    React.useEffect(() => {
        if(wareHouseArr.length && warehouses.length)return;
        getWarehouses();
    }, []);

    React.useEffect(() => {
        getWarehousesDetails();
    }, [selWarehouse]);

    React.useEffect(() => {
        setSelFiltersMessage(t('filters.selectWarehouseNDateFilters'))
        if(selWarehouse && selWarehouse.length > 0 && date !== null) {
            setSelFiltersMessage('');
        }
    }, [ready, date, selWarehouse]);


    const getEffectiveDate=(dateChange)=>{
        if(dateChange!==undefined){
            let effTime = formatDateByTimezone(dateChange);
            return effTime;
        }
    }

    const getWarehouses = async () => {
        if(wareHouseArr.length>0)return;
        try {
           const resp = await APIEndpoint.get('warehouses');
        if (resp.result.length > 0) {
            setWareHouseArr(resp.result);
            const options = [{key: 0, label: 'Select Warehouse', value: ''}];
            resp.result.filter( (fieldValue, index) => {
              options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.value}`});
              return fieldValue;
            });
            setWarehouses(options);
        }
        } catch (error) {

        }

    }


    const filterData = {
        action: 4,
        collection: '',
        filterOperation: 'or',
        filters: [],
        limit: 50,
        page: 1,
        searchParam: ''
    };

    const fetchWarehouseInventoryRows = useCallback(async (page=1, perPage=50) => {
        if( selWarehouse?.length > 0 && date!==null){
            filterData.page = page;
            filterData.limit = perPage;
            filterData.searchParam = searchKey;
            filterData.filters=[{ targetDate: getEffectiveDate(date)}, { warehouseId: getWarehousesDetails()}];
            const res = await APIEndpoint.post('warehouses/inventory/process', JSON.stringify(filterData));
            return res;
        }
        else{
            setNoResultsMessage("Please select Warehouse & Date filters");
            return {
                items:[],count:0
            }
        }
    },[date, selWarehouse,searchKey])

    const onSearch = (e) => {
        setSearchKey(e.target.value);
    };

    const onItemTypeChange = (e) => {
        setSelWarehouse(e?.value);
    }

    const getWarehousesDetails = () =>{
        if(selWarehouse && selWarehouse.length>0 && wareHouseArr.length>0){
            const wareHs = wareHouseArr.find(w=>w.value===selWarehouse)
            return wareHs?.id;
        }
    };
    const onDateSelect = (e) => {
       setDate(e.target.value)
    }

    return (
        <>
            <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
                {
                    <>

                        <div className="flexRow width100 margBot10 margTop8 justifyContentFlexStart">
                        <button className='saleType-div m-2' style={{height:'2.8rem'}}>
                                <CustomSelect
                                  options={warehouses}
                                  placeHolder="Search Warehouse"
                                  onChange={onItemTypeChange}
                                />
                                </button>
                                <div className={`dialog__description`}>
                                 <NGODatePicker
                                    isclearable={false}
                                    value={date}
                                    placeholder={t('effectiveDate')}
                                    placeholdertext={t('datePickerPlaceholder')}
                                    onChange={onDateSelect}
                                    maxDate={new Date()}
                                />
                            </div>
                            <div className="flexRow width100 margBot10 margTop8 justifyContentSpaceBetween">
                            <div className=" margLeft margBot10 underline margTop10">
                                <span><img  className="icon-size" alt={t('filters.searchText')} src={searchIcon} /></span>
                                <span><input className="search" onChange={onSearch} type="search" placeholder={t('filters.searchText')} value={props.searchKey}/></span>
                            </div>
                            </div>
                        </div>
                        <>
                            <DataGrid
                                className="full-flex"
                                columns={Columns}
                                initialPageLimit={pageLimit}
                                showDefaultFilters={false}
                                searchKey={searchKey}
                                selWarehouse={selWarehouse}
                                date={date}
                                getRows={fetchWarehouseInventoryRows}
                                noResultsMessage={ noResultsMessage }
                                rowSelection="multiple"
                                columnResize={true}
                            />
                        </>

                    </>
                }
                {
                  !ready &&<div className='overlay_hide sub'></div>
                }
            </div>
        </>
    );
}
